export const REMOVE_BONUS_POPUP_ERROR_TITLE = 'playtech.mobile.system.balance.removeBonusMessageError';
